import { observable } from 'mobx'
import { User } from '@/features/iam/users/User'
import { Id } from '@/infra/id'
import { Model, type ModelProps } from '@/infra/model'
import { unixEpoch } from '@/utils/date-util'
import type { TransactionType } from '@/features/payouts/transaction-type'
import type { TransactionSourceType } from '@/features/payouts/transaction-source-type'
import type { UserTransactionReason } from '@/features/payouts/user-transaction-reason'
import { type DraftPayout } from './DraftPayout'
import { Workspace } from '@/features/iam/workspaces/Workspace'
import type { TransactionFlag } from '@/features/payouts/transaction-flag'

export type ApprovedTransactionProps = ModelProps<ApprovedTransaction>

/**
 * A transaction that has been approved for payout.
 */
export class ApprovedTransaction extends Model<ApprovedTransaction> {
  id = Id.none
  @observable accessor shortId = ''
  @observable accessor amount = 0
  @observable accessor createdAt = unixEpoch()
  @observable accessor transactedAt = unixEpoch()
  @observable accessor type: TransactionType = 'Payment'
  @observable accessor recipient = User.none
  @observable accessor workspace = Workspace.none
  @observable accessor source: TransactionSourceType = 'Unknown'

  @observable accessor reason: UserTransactionReason | null = 'Unknown'

  @observable accessor jobId = Id.none

  @observable accessor flags: TransactionFlag[] = []

  @observable accessor approvedBy = User.none
  @observable accessor approvedAt = unixEpoch()

  constructor(public readonly draft: DraftPayout) {
    super()
  }
}
